/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanyItemDTO
 */
export interface CompanyItemDTO {
    /**
     * 
     * @type {boolean}
     * @memberof CompanyItemDTO
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompanyItemDTO
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyItemDTO
     */
    companyName?: string;
    /**
     * 
     * @type {Date}
     * @memberof CompanyItemDTO
     */
    created?: Date;
    /**
     * 
     * @type {string}
     * @memberof CompanyItemDTO
     */
    fiscalId?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyItemDTO
     */
    licence?: CompanyItemDTOLicenceEnum;
    /**
     * 
     * @type {Date}
     * @memberof CompanyItemDTO
     */
    modified?: Date;
    /**
     * 
     * @type {string}
     * @memberof CompanyItemDTO
     */
    tenant?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyItemDTO
     */
    tenantName?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyItemDTO
     */
    warehousePolicy?: CompanyItemDTOWarehousePolicyEnum;
}


/**
 * @export
 */
export const CompanyItemDTOLicenceEnum = {
    Im: 'IM',
    Wm: 'WM',
    WmWithContainer: 'WM_WITH_CONTAINER'
} as const;
export type CompanyItemDTOLicenceEnum = typeof CompanyItemDTOLicenceEnum[keyof typeof CompanyItemDTOLicenceEnum];

/**
 * @export
 */
export const CompanyItemDTOWarehousePolicyEnum = {
    Lifo: 'LIFO',
    StrictFifo: 'STRICT_FIFO',
    TimeIntervalFifo: 'TIME_INTERVAL_FIFO'
} as const;
export type CompanyItemDTOWarehousePolicyEnum = typeof CompanyItemDTOWarehousePolicyEnum[keyof typeof CompanyItemDTOWarehousePolicyEnum];


/**
 * Check if a given object implements the CompanyItemDTO interface.
 */
export function instanceOfCompanyItemDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CompanyItemDTOFromJSON(json: any): CompanyItemDTO {
    return CompanyItemDTOFromJSONTyped(json, false);
}

export function CompanyItemDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyItemDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'active': !exists(json, 'active') ? undefined : json['active'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'companyName': !exists(json, 'companyName') ? undefined : json['companyName'],
        'created': !exists(json, 'created') ? undefined : (new Date(json['created'])),
        'fiscalId': !exists(json, 'fiscalId') ? undefined : json['fiscalId'],
        'licence': !exists(json, 'licence') ? undefined : json['licence'],
        'modified': !exists(json, 'modified') ? undefined : (new Date(json['modified'])),
        'tenant': !exists(json, 'tenant') ? undefined : json['tenant'],
        'tenantName': !exists(json, 'tenantName') ? undefined : json['tenantName'],
        'warehousePolicy': !exists(json, 'warehousePolicy') ? undefined : json['warehousePolicy'],
    };
}

export function CompanyItemDTOToJSON(value?: CompanyItemDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'active': value.active,
        'address': value.address,
        'companyName': value.companyName,
        'created': value.created === undefined ? undefined : (value.created.toISOString()),
        'fiscalId': value.fiscalId,
        'licence': value.licence,
        'modified': value.modified === undefined ? undefined : (value.modified.toISOString()),
        'tenant': value.tenant,
        'tenantName': value.tenantName,
        'warehousePolicy': value.warehousePolicy,
    };
}

